<!--
   Created by Terence on 2022/9/13 - 11:05
-->
<template>
  <div @click="handleClick">
    <img
      :class="`banner`"
      src="https://assets.qiandaocdn.com/admin-upload/3f71d77c187fa6835a48c84197c331f8.png"
      alt=""
    />
  </div>
</template>

<script setup>
import { defineEmits } from "vue";

const emits = defineEmits(["onInvokeApp"]);

const handleClick = () => {
  emits("onInvokeApp");
};
</script>

<style lang="scss" scoped>
.banner {
  display: block;
  width: 100%;
  height: auto;
}
</style>
